import type { DraftMatterStatus } from "@/types/drafting";

export const DRAFT_MATTER_STATUS_ORDER: DraftMatterStatus[] = [
  "setup",
  "background",
  "drafting",
  "review",
  "export",
  "completed",
];

/** Legacy workflow value before `drafting` was standardized. */
export function normalizeDraftMatterStatus(status: string): DraftMatterStatus | string {
  if (status === "draft") return "drafting";
  return status;
}

export function draftMatterStatusRank(status: string): number {
  const normalized = normalizeDraftMatterStatus(status);
  const index = DRAFT_MATTER_STATUS_ORDER.indexOf(normalized as DraftMatterStatus);
  return index >= 0 ? index : 0;
}

export function shouldAdvanceDraftMatterStatus(current: string, target: DraftMatterStatus): boolean {
  return draftMatterStatusRank(target) > draftMatterStatusRank(current);
}

export function draftMatterStatusLabel(status: string): string {
  const normalized = normalizeDraftMatterStatus(status);
  if (normalized === "drafting") return "draft";
  return String(normalized).replace(/_/g, " ");
}

/** True once a working draft version exists (user can skip regeneration). */
export function draftMatterHasGeneratedDraft(matter: {
  status?: string | null;
  current_version_id?: string | null;
  versions?: Array<unknown> | null;
}): boolean {
  if (matter.current_version_id) return true;
  return (matter.versions?.length ?? 0) > 0;
}
